import { render, staticRenderFns } from "./Lista-de-precios.vue?vue&type=template&id=23786b14"
import script from "./Lista-de-precios.vue?vue&type=script&lang=js"
export * from "./Lista-de-precios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports